import { localizedStrings } from '@core/strings'
import React from 'react'
import { DialogTitle, IconButton, ButtonGroup } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { useModal } from '@common/GlobalModal'
import { Box, Flex } from '@fundamentals'
import { Button } from '@common/material'
import { ModalDialogContainer } from '@common/modal/ModalDialogContainer'

interface VideoModalProps {
  title?: string
  previewUrl: string
  downloadUrl?: string
}

export const VideoModal: React.FC<VideoModalProps> = ({
  title = localizedStrings.video,
  previewUrl,
  downloadUrl,
}) => {
  const { hideModal } = useModal()

  return (
    <ModalDialogContainer maxWidth='lg'>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        <Box>{title}</Box>
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>

      <Box width='100%' mb={1.5} px={2}>
        <video
          src={previewUrl}
          controls
          autoPlay
          playsInline
          controlsList='nodownload'
          style={{ width: '100%', maxHeight: '80vh', backgroundColor: 'black' }}
        />
      </Box>

      {!!downloadUrl && (
        <Flex justifyContent='flex-end' sx={{ pb: 2, pr: 2, gap: 1 }}>
          <ButtonGroup variant='contained'>
            <Button
              component='a'
              href={downloadUrl}
              sx={{ textDecoration: 'none' }}
            >
              {localizedStrings.download}
            </Button>
          </ButtonGroup>
        </Flex>
      )}
    </ModalDialogContainer>
  )
}
